/* Fathom Thread v1: collection/search. Mở sheet lọc; "Clear all" trong sheet chỉ xoá bản nháp; đóng sheet = bỏ nháp (dựng lại form);
   "Load more" nạp trang sau, gắn thẻ vào lưới (link trang thật vẫn là dự phòng); lỗi thì giữ thẻ cũ và cho thử lại. */
(function () {
  'use strict';
  if (window.FtGrid) return;
  window.FtGrid = true;
  function init() {
    document.querySelectorAll('[data-ftg]:not([data-ftg-ready])').forEach(function (root) {
      root.setAttribute('data-ftg-ready', '1');
      var sheet = root.querySelector('[data-ftg-sheet]'), form = root.querySelector('[data-ftg-form]');
      var snapshot = form ? form.innerHTML : '';
      var open = root.querySelector('[data-ftg-open]');
      if (open && sheet) open.addEventListener('click', function () { window.FtSheet.open(sheet, open); });
      if (sheet && form) {
        sheet.addEventListener('ft:close', function () { form.innerHTML = snapshot; });   // bỏ lựa chọn chưa áp dụng
        sheet.addEventListener('click', function (e) {
          var c = e.target.closest('[data-ftg-clear]'); if (!c) return;
          e.preventDefault();
          form.querySelectorAll('input[type=checkbox]').forEach(function (i) { i.checked = false; });
          form.querySelectorAll('input[type=number]').forEach(function (i) { i.value = ''; });
        });
        form.addEventListener('submit', function () {
          // bỏ ô giá trống để URL gọn
          form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
        });
      }
      // Desktop: thanh lọc trái áp dụng ngay khi đổi lựa chọn (ô giá áp dụng khi rời ô hoặc bấm Apply).
      var desk = window.matchMedia('(min-width: 1024px)');
      if (form) form.addEventListener('change', function (e) {
        if (!desk.matches) return;
        if (e.target.type === 'checkbox' || e.target.type === 'number') { form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; }); form.submit(); }
      });
      var sortSel = root.querySelector('[data-ftg-sort]');
      if (sortSel) sortSel.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });
      var more = root.querySelector('[data-ftg-more]'), grid = root.querySelector('[data-ftg-grid]');
      var shown = root.querySelector('[data-ftg-shown]'), err = root.querySelector('[data-ftg-err]'), retry = root.querySelector('[data-ftg-retry]');
      if (!more || !grid) return;
      function load() {
        var url = more.getAttribute('href');
        more.setAttribute('aria-busy', 'true'); more.textContent = 'Loading…'; if (err) err.hidden = true;
        fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('bad'); return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-ftg-grid]'); if (!g) throw new Error('no grid');
          [].slice.call(g.children).forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          var ns = doc.querySelector('[data-ftg-shown]'); if (ns && shown) shown.textContent = ns.textContent;
          var nm = doc.querySelector('[data-ftg-more]');
          if (nm) { more.setAttribute('href', nm.getAttribute('href')); more.removeAttribute('aria-busy'); more.textContent = 'Load more'; }
          else more.remove();
        }).catch(function () {
          more.removeAttribute('aria-busy'); more.textContent = 'Load more'; if (err) err.hidden = false;
        });
      }
      more.addEventListener('click', function (e) { e.preventDefault(); if (!more.hasAttribute('aria-busy')) load(); });
      if (retry) retry.addEventListener('click', load);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
